import { VersionInfoType } from "@/components/VersionInfo/VersionInfo";
import axios from "axios";


export async function getAppVersions(): Promise<{buildInfos: VersionInfoType[]}> {
    const gatewayUrl = import.meta.env.REACT_APP_VERSIONS_URL;
    const result = await axios.get<{buildInfos: VersionInfoType[]}>(gatewayUrl);
    return result?.data;
}